import CharityListItem from '../components/CharityListItem';
import Typography from '../components/Typography';
import Layout from '../components/Layout';
import BackButton from '../components/BackButton';
import { EventListWithArrowsAbove } from 'components/EventList/EventList';
import { inject, observer } from 'mobx-react';
import withUserContext from 'behaviors/withUserContext';
import useDonationLanding from 'hooks/useDonationLanding';
import { useNavigate } from '@reach/router';

const GiftedAmount = () => {
  return (
    <div className="rounded-full bg-[#E8E4F9] px-4 py-1.5 flex">
      <Typography weight="bold" className="text-center text-[14px] m-auto">
        $50.00
      </Typography>
    </div>
  );
};

const TrendingTopics = ({ donationLandingStore, uiStore }) => {
  useDonationLanding();
  const navigate = useNavigate();

  return (
    <Layout className="pt-2 pl-3">
      <div className="flex justify-between w-full mb-4 py-2">
        <BackButton />
        <GiftedAmount />
      </div>
      <Typography className="mb-6 text-[30px] text-center" weight="bold">
        Minnesota Immigration
      </Typography>
      <div className="mb-8">
        <EventListWithArrowsAbove
          title="Join Popular Cauzes"
          events={donationLandingStore.topCauzes}
          loading={donationLandingStore.loadingCauzes}
          uiStore={uiStore}
        />
      </div>
      <Typography weight="bold" className="mb-4 text-[20px]">
        Nonprofits
      </Typography>
      <div className="flex flex-col gap-y-4">
        <CharityListItem onClick={() => navigate(`/gift-redeem/checkout`)} />
        <CharityListItem />
        <CharityListItem />
        <CharityListItem />
        <CharityListItem />
      </div>
    </Layout>
  );
};

export default withUserContext(
  inject(
    'donationLandingStore',
    'uiStore',
    'userProfileStore',
  )(observer(TrendingTopics)),
);
